/* Item */

export const SALES_POINTS_CHANGE_ORGANISATION = 'POINT_CHANGE';
export const SALES_POINTS_CHANGE_ORGANISATION__SUCCESS = 'POINT_CHANGE__SUCCESS';
export const SALES_POINTS_CHANGE_ORGANISATION__FAILIRE = 'POINT_CHANGE__FAILIRE';
export const change = ({ value } = {}) => ({ type: SALES_POINTS_CHANGE_ORGANISATION, value });
